import { StatusResource } from 'api'

/**
 * Order platform name. The values should match with the OrderPlatform.internal_name in the Chowly API
 */
export enum PlatformName {
  CHOWLY = 'Chowly',
  UBEREATS = 'Ubereats',
  DOORDASH = 'Doordash',
  GRUBHUB = 'GrubCentral',
  GARCON = 'Garcon',
  POSTMATES = 'Postmates',
  CHOWNOW = 'Chownow',
  DELIVERY = 'DeliveryDotCom',
  CAVIAR = 'Caviar',
  RITUAL = 'Custom',
  COO = 'Chowly Online Ordering',
}

export enum PlatformFriendlyName {
  CHOWLY = 'Chowly',
  UBEREATS = 'Uber Eats',
  DOORDASH = 'DoorDash',
  GRUBHUB = 'GrubCentral',
  GARCON = 'Garcon',
  CHOWNOW = 'Chownow',
  DELIVERY = 'DeliveryDotCom',
  CAVIAR = 'Caviar',
  RITUAL = 'Custom',
}

/**
 * Platform names as they appear in the reporting_orders.platform_name database field
 * These values match 1-1 with the actual database values
 */
export enum ReportingOrdersPlatformName {
  ALLSET = 'Allset',
  APP2FOOD = 'App2Food',
  APPETIT = 'Appetit',
  BBOT = 'Bbot',
  BIGGORDER = 'BiggOrder',
  BISTROSTACK = 'Bistrostack',
  BLIZZFULL = 'Blizzfull',
  BRINGMETHAT = 'BringMeThat',
  CAPTAIN = 'Captain',
  CHOWLY_ONLINE_ORDERING = 'Chowly Online Ordering',
  DATADREAMERS = 'DataDreamers',
  DELIVERLOGIC = 'DeliverLogic',
  DELIVERY_DOT_COM = 'Delivery.com',
  DEVOUR = 'Devour',
  DICKEYSOO = 'DickeysOO',
  DOORDASH = 'DoorDash',
  EATSTREET = 'EatStreet',
  ELEVATE = 'Elevate',
  EZCATER = 'ezCater',
  FANTUAN = 'Fantuan',
  FASTBITE = 'FastBite',
  FOODDUDES = 'FoodDudes',
  FOX_ORDERING = 'Fox Ordering',
  GARCON = 'Garcon',
  GRUBHUB = 'Grubhub',
  INFI = 'Infi',
  INFINET = 'Infinet',
  MEALEO = 'Mealeo',
  MENUFY = 'Menufy',
  NOSH = 'Nosh',
  NOVOLABS = 'NovoLabs',
  REAL_TIME_ORDERING = 'Real Time Ordering',
  REDDIE = 'Reddie',
  RITUAL = 'Ritual',
  SAUCE = 'Sauce',
  SERVY = 'Servy',
  SHAREBITE = 'Sharebite',
  SKIPTHEDISHES = 'SkipTheDishes',
  SNACKPASS = 'Snackpass',
  TAKEOUTCENTRAL = 'TakeoutCentral',
  UBEREATS = 'UberEats',
  ZENDELIVERY = 'Zendelivery',
  ZUPPLER = 'Zuppler',
}

export type PlatformSummary = {
  name: string
  internalName: string
  status: string
  aasmState?: string
  menuPublishStatus?: StatusResource
  availability: string
  reopenTime?: string | null
  pausable: boolean
  id: number
  provisioned: boolean
  hasAccessToken: boolean
  hasOnboardingId: boolean
  buydown?: boolean | null
  buydown_fee?: number | null
  minimum_delivery_subtotal?: number | null
  coo_url?: string | null
}
